<template>
  <div>
    <div class="card-header pl-0">
      <div class="d-flex justify-content-between align-items-center">
        <div class="dropdown mr-3 d-none">
          <button
            class="btn btn-card-header dropdown-toggle"
            type="button"
            id="inspectorDropdown"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <img src="~@/assets/addplus_icon.svg" class="heading-icon mr-2"/>
            <span class="pr-2 text-capitalize"> Add</span>
          </button>

          <ul class="dropdown-menu" aria-labelledby="inspectorDropdown">
            <li class="d-none"><span class="dropdown-item" @click="activeComponent = 'default'">Default</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'main'">Main</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'animations'">Animations</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'light'">Light</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'sound'">Sound</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'movement'">Movement</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'effects'">Effects</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'tts'">TTS</span></li>
          </ul>
        </div>
        <span class="ml-3"><img class="heading-icon mr-2" src="~@/assets/device_hub_icon.svg"/> Inspector</span>
        <span class="text-primary ml-3">
          {{ $parent.activeComponentTitle }}
        </span>

        <div class="btn-menu-wrapper navbar navbar-expand-lg">
          <ul class="navbar-nav">
            <li class="nav-item">
              <span class="nav-link"
                    @click="activeComponent = 'main'"
                    :class="{'active':activeComponent == 'main'}">
                Main
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="inspector-wrapper">

      <div class="row">
        <div class="col-9">
          <maininspector v-if="activeComponent == 'main'"></maininspector>
        </div>
        <div class="col-3">
          <h4 v-if="selectedCharecterName">{{ selectedCharecterName }}</h4>
          <div class="selected-char-imgwrap">
            <img :src="selectedCharecter" class="img-fluid"/>
          </div>
        </div>
      </div>
      <div class="row mt-4 d-none">
        <div class="col-12 text-center">
          <button class="btn btn-outline-primary mr-3">Save</button>
          <button class="btn btn-outline-secondary">Cancel</button>
        </div>
      </div>
  </div>
  </div>
  </div>
</template>

<script>

import maininspector from '../inspector-components/lights/maininspector'
import $ from 'jquery'

export default {
  name: 'lightsInspector',
  data () {
    return {
      showModal: false,
      activeComponent: 'main',
      selectedCharecter: '',
      selectedCharecterName: ''
    }
  },
  created () {
    this.openModal()
  },
  components: {
    maininspector
  },
  methods: {
    openModal () {
      this.showModal = true
      this.$nextTick(() => {
        $('#lights-modal').modal('show')
      })
    },
    closeModal () {
      $('.modal').modal('hide')
      this.showModal = false
    },
    changeShadow () {
      this.$emit('showShadowChange', {'showShadow': this.showShadow})
    },
    changeSkeleton () {
      this.$emit('showSkeletonChange', {'showSkeletonToggle': this.showSkeleton})
    },
    changeSelectedAnimation (data) {
      this.$emit('showSelectedAnimation', {'selectedAnimation': data.selectedAnimation})
    },
    changeSelectedModel (data) {
      this.selectedCharecter = data.imageurl
      this.selectedCharecterName = data.name
      this.$emit('showSelectedModel', {'selectedFbxModel': data.index})
    }

  }
}
</script>




// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-wrap/lightsInspector.vue